
import { useEffect, useRef } from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const Success = () => {
  const searchInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    // Set page title
    document.title = "Search Safe - Search Engine";

    // Send UTMs message when the page loads
    window.postMessage(
      {type: "SEND_UTMS", utms: localStorage.getItem('utms')}, "*"
    );

    // Focus the search input
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, []);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);
    const query = formData.get('q') as string;
    if (query.trim()) {
      window.open(`https://www.searchsafesecurity.com/search?q=${encodeURIComponent(query)}`, '_blank');
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header with logo */}
      <header className="flex justify-center pt-16 pb-4">
        <img 
          src="/lovable-uploads/dc63e580-673d-48c8-b445-463453e2a531.png" 
          alt="Search Safe Security" 
          className="h-12"
          loading="eager" 
        />
      </header>

      {/* Main content */}
      <main className="flex-1 flex flex-col items-center justify-start pt-16">
        <div className="w-full max-w-2xl px-4">
          {/* Search box */}
          <form onSubmit={handleSearch} className="mb-8">
            <div className="relative">
              <Input
                ref={searchInputRef}
                type="text"
                name="q"
                placeholder="Try a search now..."
                className="w-full h-12 pl-4 pr-12 text-lg border-2 border-gray-300 rounded-full shadow-sm hover:shadow-md focus:shadow-md transition-shadow"
                autoComplete="off"
              />
              <Button
                type="submit"
                size="sm"
                className="absolute right-2 top-2 h-8 w-8 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-600"
                variant="ghost"
              >
                <Search className="h-4 w-4" />
              </Button>
            </div>
          </form>

          {/* Success message */}
          <div className="text-center bg-green-50 border border-green-200 rounded-lg p-4 mb-4">
            <p className="text-green-800 font-medium">
              ✓ Search Safe extension has been added successfully!
            </p>
            <p className="text-green-700 text-sm mt-1">
              You're now protected with enhanced search security and privacy.
            </p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-6 border-t border-gray-200">
        <div className="flex justify-center space-x-6 text-sm text-gray-600">
          <a 
            href="https://www.searchsafesecurity.com" 
            className="hover:text-blue-600 transition-colors"
            target="_blank"
            rel="noopener noreferrer"
          >
            Home
          </a>
          <a 
            href="https://www.searchsafesecurity.com/privacy" 
            className="hover:text-blue-600 transition-colors"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
        </div>
      </footer>
    </div>
  );
};

export default Success;
